'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import styled from '@emotion/styled';

const _ = {
    filter: require('lodash/filter'),
    find: require('lodash/find'),
    findIndex: require('lodash/findIndex'),
    forEach: require('lodash/forEach'),
    isEmpty: require('lodash/isEmpty'),
    map: require('lodash/map'),
    reject: require('lodash/reject'),
    uniq: require('lodash/uniq'),
};

const ServerRequest = require('../../actions/request');
const KeyboardUtil = require('../../util/keyboard');
const verUtil = require('../../util/version.js');
import SortableTable2 from '../table/SortableTable2';
import ErrorBox from '../common/ErrorBox';
import AccessibleIcon from '../common/AccessibleIcon';
import AutoSizeTextArea from '../common/AutoSizeTextArea';
import LoadingMainContent from '../loading/LoadingMainContent';

let EditDiv = styled.div`
    padding: 1rem 3rem;
    margin: 1rem;
    background: lightgrey;
    border: solid thin grey;
    textarea {
        display: block;
        width: 100%;
    }
`;

let PlaybookDetailDiv = styled.div`
    padding: 1rem 3rem;
    margin: 1rem;
    border: solid thin grey;
    font-size: 1.6rem;
    h2 {
        font-size: 2.2rem;
        margin-bottom: 1rem;
    }
    div {
        margin-bottom: 0.5rem;
    }
    label {
        width: 10rem;
    }
`;

class AdminTemplatePlaybooks extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // the only current template with boilerplate
            app_key: 'sfc', 
            app_name: 'Smart Chat',
            selected_row_id: null,
            selected_playbook_id: null,
            rows: [],
            playbooks: [],
            loadingBoilerplate: true,
            loadingPlaybooks: true,
            saving: false,
            latestVersionsOnly: false,
        };
        this.unsubscribes = [
            // RegisterStore.listen(this.onRegisterStoreStateChange.bind(this))
        ];
    }
    
    componentDidMount() {
        this.mzl_mounted = true;
        this.requestBoilerplate()
        this.requestPlaybooks();
    }
    
    componentWillUnmount() {
        delete this.mzl_mounted;
        this.unsubscribes.forEach(u => u());
    }
    
    requestBoilerplate=()=>{
        const appKey = this.state.app_key;
        let body = {
            appKey,
            playbooks: 'allVersions',
            onlyPlaybookStrings: true,
        };
        // load the boilerplate
        let url = `/authoring/template_boilerplate`;
        return ServerRequest.makeRequest(url, 'POST',JSON.stringify(body))
        .then((template_boilerplate)=>{
            let rows = _.map(template_boilerplate,(row,i)=>{
                return { ...row, changed: false };
            });
            if (this.mzl_mounted){ 
                this.setState({rows, loadingBoilerplate:false});
            }
            return null;
        })
        .catch((error)=>{
            if (this.mzl_mounted){ 
                this.setState({loadingBoilerplate:false, error});
            }
        });
    }

    requestPlaybooks=()=>{
        const appKey = this.state.app_key;
        // load all playbooks for the specified template
        let url = `/authoring/ai_playbooks/${appKey}`;
        return ServerRequest.makeRequest(url, 'GET')
        .then((playbooks)=>{
            if (this.mzl_mounted){ 
                this.setState({playbooks, loadingPlaybooks:false});
            }
            return null;
        })
        .catch((error)=>{
            if (this.mzl_mounted){ 
                this.setState({loadingPlaybooks:false, error});
            }
        });
    }
    
    selectPlaybook=(e)=>{
        const playbooks = this.state.playbooks;
        let id = e.target.value;
        // match the type
        if (typeof playbooks[0].id === 'number') {
            id = Number(id);
        }
        this.setState({ selected_playbook_id: id});
    }
    
    onLatestVersionsOnly=(e)=>{
        let latestVersionsOnly = e.target.checked;
        this.setState({latestVersionsOnly});
    }
    
    
    copySelectedPlaybook=()=>{
        const playbooks = this.state.playbooks;
        const selectedPlaybook = _.find(playbooks,{id:this.state.selected_playbook_id});
        if (!selectedPlaybook) {
            return;
        }
        let rows = _.filter(this.state.rows,(row)=>{
            let { string_id, version } = row;
            return _.find(selectedPlaybook.string_keys,{ string_id, version }) ? true : false;
        });

        rows = _.map(rows,(row)=>({
            string_id: row.string_id,
            version: row.version,
            string_value: row.string_value,
            published: row.published
        }));
        
        let playbookForClipboard = { ...selectedPlaybook };
        delete playbookForClipboard.id;
        delete playbookForClipboard.created_at;
        delete playbookForClipboard.modified_at;
        delete playbookForClipboard.published_on;
        delete playbookForClipboard.published_by;        
        
        let playbookData = {
            playbook: playbookForClipboard,
            strings: rows
        }
        
        let textToCopy = JSON.stringify(playbookData);
        var $temp = $("<input>");
        $("body").append($temp);
        $temp.val(textToCopy).select();
        document.execCommand("copy");
        $temp.remove();
        this.setState({copied:true},()=>{
            setTimeout(()=>{
                this.setState({copied:false});
            },5000);
        });
    }
    
    pastePlaybook=()=>{
        return navigator.clipboard.readText()
        .then((text)=>{
            let pastedPlaybookData;
            try {
                 pastedPlaybookData = JSON.parse(text);
            }
            catch(err) {
                console.log("error parsing clipboard data",err);
                let error = new Error("Failed to parse clipboard");
                this.setState({pastedPlaybookData:null, error});
                return;
            }
            
            // validate the data
            try {
                let { playbook, strings } = pastedPlaybookData;
                if ((typeof playbook !== 'object') || !strings || !strings.length) {
                    throw new Error("data in clipboard is not valid playbook data");
                }
                let { hash, version, name, purpose, string_keys, model_ids } = playbook;
                if (!hash || !version || !name || !purpose  || !string_keys || !model_ids) {
                    throw new Error("data in clipboard is not valid playbook data");
                }
                let unique_string_ids = _.uniq(_.map(string_keys,'string_id'));
                if (unique_string_ids.length !== string_keys.length) {
                    throw new Error("clipboard playbook string_keys has multiple values for 1 or more string_ids");
                }
                let matchMap = {};
                let badStringCount = 0;
                let matchCount = 0;
                _.forEach(strings,(bp)=>{
                    let {string_id, string_value, version} = bp;
                    if (!string_id || !version || (typeof string_value !== 'string')) {
                        badStringCount++;
                    }
                    let test = _.find(string_keys,{string_id,version});
                    if (!test) {
                        badStringCount++;
                        return;
                    }
                    if (!matchMap[string_id]) {
                        matchMap[string_id] = version;
                        matchCount++;
                        return;
                    }
                    console.log("multiple strings with string_id",string_id);
                    console.log("same version?", matchMap[string_id].version, version);
                    badStringCount++;
                });
                if (matchCount != string_keys.length) {
                    throw new Error("clipboard playbook was missing some strings"); 
                }
                this.setState({pastedPlaybookData, error: null});
            }
            catch(error) {
                console.log("playbook with error(s):",pastedPlaybookData);
                this.setState({pastedPlaybookData:null, error});
            }
        });
    }

    savePastedPlaybook=()=>{
        let { playbook, strings } = this.state.pastedPlaybookData;
        const appKey = this.state.app_key;
        // load all playbooks for the specified template
        const data = {
            appKey,
            playbook,
            strings
        };
        this.setState({loadingBoilerplate: true,loadingPlaybooks: true,},()=>{
            return ServerRequest.makeRequest('/authoring/paste_ai_playbook', 'POST',JSON.stringify(data))
            .then((result)=>{
                if (this.mzl_mounted){ 
                    this.setState({pastedPlaybookData:null},()=>{
                        this.requestBoilerplate();
                        this.requestPlaybooks();
                    });
                }
                return null;
            })
            .catch((error)=>{
                if (this.mzl_mounted){ 
                    this.setState({pastedPlaybookData:null, error});
                }
            });
        });
    }

    cancelPaste=()=>{
        this.setState({pastedPlaybookData:null});
    }

    render() {
        if (this.state.loadingBoilerplate || this.state.loadingPlaybooks) {
            return (
                <LoadingMainContent />
            )
        };
        const playbooks = this.state.playbooks;
        const tableTitle = "Playbook Strings";

        let selectedPlaybook = _.find(playbooks,{id:this.state.selected_playbook_id});
        let rows = selectedPlaybook ? _.filter(this.state.rows,(row)=>{
            let { string_id, version } = row;
            return _.find(selectedPlaybook.string_keys,{ string_id, version }) ? true : false;
        }) : [];

        let upperElements = [];
        let columns = [
            {
                displayName: 'id',
                key:'id',
                width: '3rem',
                type: 'number'
            },
            {
                displayName: 'Version',
                key:'version',
                width: '5rem',
                type: 'string'
            },
            {
                displayName: 'Published',
                key:'published',
                width: '5rem',
                type: 'bool'
            },
            {
                displayName: 'String ID',
                key:'string_id',
                width: '15rem',
                type: 'string'
            },
            {
                displayName: 'String',
                key:'string_value',
                width: '60%',
                type: 'string'
            },
        ];

        let displayColumnCallbacks;
        if (this.state.pastedPlaybookData) {
            let { playbook, strings } = this.state.pastedPlaybookData;
            let overwriteQuery = {
                app_key: playbook.app_key,
                hash: playbook.hash,
                version: playbook.version,
            };
            let overwritePlaybook = _.find(playbooks,overwriteQuery);
            rows = [];
            _.forEach(strings,(row,i)=>{
                let changeText = 'add';
                let {string_id, version} = row;
                let existingRow = _.find(this.state.rows,{string_id, version});
                if (existingRow) {
                    if (row.string_value === existingRow.string_value) {
                        if (row.published != existingRow.published) {
                            if (row.published) {
                                changeText = "publish";
                            }
                            else if (existingRow.published) {
                                changeText = "unpublish";
                            }
                            else {
                                changeText = 'pub change'; // shouldn't happen, right?
                            }
                        }
                        else {
                            changeText = 'no change';
                        }
                    }
                    else {
                        changeText = 'replace';
                        if (existingRow.published) {
                            changeText = 'replace published';
       
                        }
                    }
                }
                rows.push({
                    ...row, 
                    id: (i+1),
                    changeText
                }); // fake the string id
            })
            columns.push({
                displayName: 'Action',
                key:'changeText',
                width: '7rem',
                type: 'custom'
            });
            
            displayColumnCallbacks={
                changeText: (changeText,id)=>{
                    let changeClass="";
                    if (changeText === 'replace') {
                        changeClass = "warning-text";
                    }
                    else if (changeText === 'replace published') {
                        changeClass = "error-text";
                    }
                    return ( <span className={changeClass}>{changeText}</span> );
                }
            }
            
            upperElements.push(
                <PlaybookDetailDiv key='playbook-details'>
                    <h2>Playbook from clipboard</h2>
                    <div><label>{'Name:'}</label><span>{playbook.name}</span></div>
                    <div><label>{'Purpose:'}</label><span>{playbook.purpose}</span></div>
                    <div><label>{'Description:'}</label><span>{playbook.description}</span></div>
                    <div><label>{'Version:'}</label><span>{playbook.version}</span></div>
                    <div><label>{'Published:'}</label><span>{playbook.published ? 'yes':'no'}</span></div>
                </PlaybookDetailDiv>
            )
            let saveTitle = overwritePlaybook ? 'Overwrite existing playbook' : 'Save new playbook from clipboard';
            upperElements.push(
                <Button key='save' onClick={this.savePastedPlaybook}>
                    {saveTitle}
                </Button>
            );
            upperElements.push(
                <Button key='cancel' onClick={this.cancelPaste}>
                    Cancel
                </Button>
            );
        }
        else {
            function pbSort(a,b) {
                if (a.purpose == b.purpose) {
                    let v = verUtil.parseVersion(a.version);
                    return v.compare(b.version);
                }
                else if (a.purpose < b.purpose) {
                    return -1;
                }
                else {
                    return 1;
                }
            }
            
            let filteredPlaybooks = this.state.playbooks;
            if (this.state.latestVersionsOnly) {
                filteredPlaybooks = [];
                _.forEach(this.state.playbooks,(pb)=>{
                    let v = verUtil.parseVersion(pb.version);
                    let i = _.findIndex(filteredPlaybooks,{purpose:pb.purpose,published:pb.published});
                    let xr = filteredPlaybooks[i];
                    if (xr) {
                        let c = v.compare(xr.version);
                        if (c > 0) {
                            filteredPlaybooks[i] = pb;
                        }
                    }
                    else {
                        filteredPlaybooks.push(pb);
                    }
                });
                filteredPlaybooks.sort(pbSort);
            }
            else {
                filteredPlaybooks = filteredPlaybooks.slice();
                filteredPlaybooks.sort(pbSort);
            }
            upperElements.push(
                <label key='playbook-selector'>{'playbook:'}
                    <select value={this.state.selected_playbook_id || ''} onChange={this.selectPlaybook}>
                        <option hidden value={''}>{'Select a playbook'}</option>
                    {_.map(filteredPlaybooks,(pb,i)=>(
                        <option key={i} value={pb.id}>{`${pb.purpose} "${pb.name}" ${pb.version} ${pb.published?"(published)":""} id:${pb.id}`}</option>
                    ))}
                    </select>
                </label>
            );
            upperElements.push(
                <span className="inline-checkbox" key='playbook-select-filter'>
                    <input type="checkbox" onChange={this.onLatestVersionsOnly} checked={this.state.latestVersionsOnly} id="playbook-filter-latest-versions-only"/>
                    <label htmlFor="playbook-filter-latest-versions-only">{'latest versions only'}</label>
                </span>
            );            
            
            
            upperElements.push(
                <Button key='copy' onClick={this.copySelectedPlaybook} disabled={this.state.copied || !selectedPlaybook}>
                    {this.state.copied ? "playbook copied to clipboard" : "Copy to clipboard"}
                </Button>
            );
            upperElements.push(
                <Button key='paste' onClick={this.pastePlaybook}>
                    Paste from clipboard
                </Button>
            );
        }

        return (
            <div className="admin-playbooks">
                <ErrorBox error={this.state.error} />
                {upperElements}
                <div className="spacer"/>
                <SortableTable2
                    key="raw-data-table"
                    title={tableTitle}
                    uniqueRowKey="id"
                    rows={rows}
                    selectedRowKey={this.state.selected_row_id}
                    columns={columns}
                    displayColumnCallbacks={displayColumnCallbacks}
                />
            </div>
        );
    }
}

//AdminTemplatePlaybooks.propTypes = {};
//AdminTemplatePlaybooks.defaultProps = {};

export default AdminTemplatePlaybooks;
